import type { CourseStatus } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type GetCourseContentParams = {
  courseId: number;
  queryParams?: {
    status?: CourseStatus;
  };
};

const { useGet: useCourseContent } = getCRUDHooks({
  entityName: 'courseContent',
  get: ({ courseId, queryParams = {} }: GetCourseContentParams) =>
    clientApi.getOCClient().helpers.learningContent.courses.getContent(courseId, queryParams),
});

export default useCourseContent;
